<template>
    <div>
        <v-layout wrap class="mb-0">
            <v-flex md9>
                <v-text-field type="text" label="Plassering" hide-details v-model="data.name"
                              class="mb-2 text-field-bold"/>
            </v-flex>
            <v-flex md3 class="text-sm-center">
                <v-btn rounded color="blue-grey lighten-5" class="blue-grey--text" @click="printSingle"
                       :disabled="!$root.printer && (!this.$root.settings.has_zpl)">
                    <v-icon>vertical_split</v-icon>
                </v-btn>
            </v-flex>

            <v-flex md12 lg6 xl4>
                <v-text-field class="mt-1" type="number" step="0.1" label="Mønster (mm)" hide-details
                              v-model="data.tread_depth" :tabindex="tabIndex"/>
            </v-flex>
            <v-flex md12 lg6 xl4>
                <v-radio-group v-model="data.state" hide-details class="mt-0">
                    <template v-slot:label>
                        <div>
                            <span>Nytt dekk?</span>
                            <v-btn x-small color="red" outlined class="ml-2" v-if="data.state"
                                   @click="data.state = null" style="float: right">
                                Tøm
                            </v-btn>
                        </div>
                    </template>
                    <v-radio v-for="item in tireStateItems" :key="item.value" :label="item.text"
                             :value="item.value"></v-radio>
                </v-radio-group>
            </v-flex>
            <v-flex md12 lg6 xl4>
                <v-checkbox color="blue-grey" label="Har sensor" hide-details v-model="data.has_sensor"/>
                <v-checkbox color="green" label="Sensor OK" hide-details v-model="data.is_sensor_working"
                            :disabled="!data.has_sensor"/>
            </v-flex>
        </v-layout>
        <v-textarea label="Merknad til dekk" rows="2" hide-details v-model="data.note"/>
    </div>
</template>
<script>
import {tireStateItems} from "@/helpers";

export default {
    name: 'tire-storage-tire-form',

    props: {
        data: Object,
        tabIndex: {}
    },

    watch: {
        'data.has_sensor'(newValue) {
            if (!newValue) this.data.is_sensor_working = false;
        }
    },

    methods: {
        printSingle() {
            this.$emit('print')
        }
    },

    computed: {
        tireStateItems() {
            return [...tireStateItems].slice(1)
        }
    }
}
</script>

<style>
.text-field-bold input {
    font-weight: bold;
}
</style>
